import { FormGroup, FormLabel, Row, Col } from 'react-bootstrap';
import { FormSpy } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import Alert from 'common/components/alert/Alert';
import FinalFormField from 'common/components/final-form/FinalFormField';
import useCodeTable from 'common/hooks/useCodeTable';
import AlertType from 'common/types/AlertType';
import DwellingTypes from 'domain/enums/DwellingTypes';
import IntermediariesList from 'common/components/intermediaries-list/IntermediaryList';

interface IDetails {
  dwellingTypeCd: DwellingTypes;
}

const Details: React.FC<IDetails> = ({ dwellingTypeCd }) => {
  const intermediaryCodes = useCodeTable({
    endpoint: '/intermediaries',
  });
  const dwellingCodes = useCodeTable({
    endpoint: '/dwellingTypes',
  });

  intermediaryCodes.sort((a, b) => a.descr.localeCompare(b.descr));

  const mappedIntermediaryCodes = intermediaryCodes.map((opt) => ({
    value: opt.cd,
    label: opt.descr,
  }));

  return (
    <>
      <FormSpy>
        {({ errors }) => (
          <>
            {errors &&
              errors.intermediaries &&
              errors.intermediaries.length > 0 && (
                <Alert type={AlertType.danger}>
                  {errors.intermediaries[0]}
                </Alert>
              )}
          </>
        )}
      </FormSpy>
      <FormGroup as={Row}>
        <FieldArray name='intermediaries'>
          {({ fields, fields: { value } }) => (
            <Col sm={{ span: 6 }}>
              <FormLabel>Please select intermediary platforms: *</FormLabel>
              <IntermediariesList
                options={mappedIntermediaryCodes}
                selectedValues={value}
                onSelect={(selectedValue) => {
                  const opt = mappedIntermediaryCodes.find(
                    (c) => c.value === selectedValue
                  );
                  fields.push({
                    cd: opt?.value,
                    descr: opt?.label,
                  });
                }}
                onRemove={(selectedValue) => {
                  const removeIdx = value.findIndex(
                    (c) => c.cd === selectedValue
                  );
                  if (removeIdx !== -1) {
                    fields.remove(removeIdx);
                  } else {
                    console.error('Item cannot be removed. Index not found.');
                  }
                }}
              />
            </Col>
          )}
        </FieldArray>
      </FormGroup>
      <FormGroup as={Row}>
        <Col sm={{ span: 6 }} className='align-self-center'>
          <FinalFormField
            name='dwellingTypeCd'
            label='What is the dwelling type of your listing: *'
            type='select'
            text='Choose entire dwelling if all rooms in your unit will be available. Otherwise choose partial dwelling.'
            options={dwellingCodes}
            when={{
              field: 'dwellingTypeCd',
              becomes: DwellingTypes.ENTIRE,
              set: 'howManyRooms',
              to: null,
            }}
          />
        </Col>
      </FormGroup>

      {(dwellingTypeCd === DwellingTypes.PARTIAL ||
        dwellingTypeCd === DwellingTypes.COMBINATION) && (
        <FormGroup as={Row}>
          <Col sm={{ span: 6 }} className='align-self-center'>
            <FinalFormField
              type='number'
              name='howManyRooms'
              label='How many rooms are you listing?'
            />
          </Col>
        </FormGroup>
      )}
    </>
  );
};

export default Details;
